import React from 'react';
import MetamaskImage from './../images/metamask.png';
import GetOnAppStore from './../images/app_store.svg';
import ReactSVG from 'react-svg';
import GetOnGooglePlay from './../images/google-play-badge.png';

export default class NoMetamask extends React.Component {
  render () {
    return (
      <div className="c-no-metamask">
        <div className="c-no-metamask__container">
          <h1>If you want to use AsyncCoin, please use MetaMask or Coinbase Wallet</h1>
          <h3>It could work on other Dapp browsers, but we aren't sure yet, sry :)</h3>
          <div className="c-no-metamask__extensions">
            <div className="c-no-metamask__extensions-item">
              <h1>Desktop</h1>
              <h3>You can install MetaMask extension by clicking the image below</h3>
              <h4>After you install MetaMask, and set it up, come back here and reload the page</h4>
              <a href="https://metamask.io/" target="_blank">
                <img src={MetamaskImage} role="presentation"/>
              </a>
            </div>
            <div className="c-no-metamask__extensions-item">
              <h1>Mobile</h1>
              <h3>You can install Coinbase wallet by clicking your platform icon below</h3>
              <h4>After you install Coinbase wallet, open this page in Coinbase wallet.</h4>
              <div className="c-no-metamask__extensions-item-platforms">
                <a
                  href='https://play.google.com/store/apps/details?id=org.toshi'
                  target="_blank">
                  <img alt='Get it on Google Play' src={GetOnGooglePlay}/>
                </a>
                <a
                  href="https://itunes.apple.com/us/app/coinbase-wallet/id1278383455?mt=8"
                  target="_blank">
                  <ReactSVG src={GetOnAppStore}/>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NoMetamask.js